import styled from "styled-components";
import { theme } from "../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Name = styled.div`
    margin-bottom: ${theme.space[1]}px;
`;

export const Item = styled.div`
    margin-bottom: ${theme.space[4]}px;
    padding-bottom: ${theme.space[3]}px;
`;

export const ListItem = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${theme.space[2]}px 0;
    border-bottom: 1px solid ${theme.colors.silver};
    &:last-child {
        margin-bottom: ${theme.space[2]}px;
    }
`;

export const Header = styled.button`
    width: 100%;
    margin-top: ${theme.space[2]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    text-align: start;
    text-transform: uppercase;
    background-color: transparent;
    border: none;
`;

export const Toggle = styled.div<{ isOpen?: boolean }>`
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    width: 100%;
`;

export const OriginalPrice = styled.span`
    margin-left: ${theme.space[1]}px;
    text-decoration: line-through;
    color: ${theme.colors.grey3};

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    ${Type.Strong} {
        margin-bottom: 0;
    }
`;
